/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 23/11/2023 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 02/06/2026 | Lic. José Luis Aragón Cervantes  | Eliminación de accesos
*      3       | 04/06/2026 | Lic. José Luis Aragón Cervantes  | Orden configurable y arrastre de menús por usuario
*      4       | 04/06/2026 | Lic. José Luis Aragón Cervantes  | Validación de edición en menús, permisos y alcances
*      5       | 08/06/2026 | Lic. José Luis Aragón Cervantes  | Resultado de guardado para menú contextual
*      6       | 08/06/2026 | Lic. José Luis Aragón Cervantes  | Helper de validación para contraseñas y claves secretas
 *      7       | 27/08/2026 | Lic. José Luis Aragón Cervantes  | Contrato estándar de menús y orden de grupos
 *      8       | 31/08/2026 | Lic. José Luis Aragón Cervantes  | Acceso Sistema > Registro de fallos solo para SA
 *      9       | 24/10/2026 | Lic. José Luis Aragón Cervantes  | Acceso a Cuentas X Cobrar por rol
 * ---------------------------------------------------------------------------------------
*/

import { createContext, useContext, useState, useMemo, useRef } from "react";
import {
    apiAccesosList,
    apiMenusListaUsuario,
    apiMenusGuardarUsuario,
    apiPermisosGuardarUsuario,
    apiAlcancesGuardarUsuario,
    apiAccesosAlcances,
    apiAccesosPermisos,
    apiAccesosMenus,
    apiAccesosData,
    apiAccesosGuardar,
    apiAccesosDelete,
} from "../../settings/ApiConfig";

import { useNavigate } from "react-router-dom";

import { getDatePost, isErrorForm, handleValidarStrings } from "../../settings/utils";
import { defaultTypes } from "../../settings/enums";

import { useRequest } from "../../context/System/RequestContext";
import { useLayout } from "../../context/System/LayoutContext";

import { useSesion } from "../../context/System/SesionContext";

export const getStructAccesos = () => ({
  id: 0,
  isNuevo: true,  
  fecharegistro: getDatePost(),

  usuario: defaultTypes.String,
  nombreusuario: defaultTypes.String,
  password: defaultTypes.String,
  confirmacion: defaultTypes.String,
  clavesecreta: defaultTypes.String,
  confirmacionclavesecreta: defaultTypes.String,
  direccion: defaultTypes.String,
  coloniacomunidad: defaultTypes.String,
  delegacionmunicipio: defaultTypes.String,
  ciudadpoblacion: defaultTypes.String,
  cp: defaultTypes.String,
  telefono: defaultTypes.String,
  email: defaultTypes.String,
  puesto: defaultTypes.String,
  tipousuario: defaultTypes.String,
  roles: defaultTypes.String,       
  alcance: 0,
  statuscomision: false,                
  comisionventa: 0,                
  foto: defaultTypes.String,    
  adicional: defaultTypes.String,
  idUsuarioCreacion: defaultTypes.String,
  idUsuarioModificacion: defaultTypes.String,
  idUsuarioBaja: defaultTypes.String,
  dteFechaCreacion: defaultTypes.DateTime,
  dteFechaModificacion: defaultTypes.DateTime,
  dteFechaBaja: defaultTypes.DateTime,
});

export const getStructAccesosDefault = () => ({
  id: 0,
  isNuevo: true,
  fecharegistro: getDatePost(),
  usuario: "",
  nombreusuario: "",
  password: "",
  confirmacion: "",
  clavesecreta: "",
  confirmacionclavesecreta: "",
  direccion: "",
  coloniacomunidad: "",
  delegacionmunicipio: "",
  ciudadpoblacion: "",
  cp: "",
  telefono: "",
  email: "",
  puesto: "",
  tipousuario: "",
  roles: "",
  alcance: 0,
  statuscomision: false,
  comisionventa: 0,
  foto: "",
  adicional: "",
});

export const getStructAccesoPayload = () => ({
  id: { value: 0, error: false, helper: "" },
  fecharegistro: { value: getDatePost(), error: false, helper: "" },
  usuario: { value: "", error: false, helper: "" },
  nombreusuario: { value: "", error: false, helper: "" },
  password: { value: "", error: false, helper: "" },
  confirmacion: { value: "", error: false, helper: "" },
  clavesecreta: { value: "", error: false, helper: "" },
  confirmacionclavesecreta: { value: "", error: false, helper: "" },
  direccion: { value: "", error: false, helper: "" },
  coloniacomunidad: { value: "", error: false, helper: "" },
  delegacionmunicipio: { value: "", error: false, helper: "" },
  ciudadpoblacion: { value: "", error: false, helper: "" },
  cp: { value: "", error: false, helper: "" },
  telefono: { value: "", error: false, helper: "" },
  email: { value: "", error: false, helper: "" },
  puesto: { value: "", error: false, helper: "" },
  tipousuario: { value: "", error: false, helper: "" },
  roles: { value: "", error: false, helper: "" },
  alcance: { value: 0, error: false, helper: "" },
  statuscomision: { value: false, error: false, helper: "" },
  comisionventa: { value: 0, error: false, helper: "" },
  foto: { value: "", error: false, helper: "" },
  adicional: { value: "", error: false, helper: "" },
});

export const getStructMenusAccesosAdministrador = () => ([
    {
        id: 1,
        menu: "Administración",
        pagina: "Devoluciones",
        path: "/devoluciones",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "D",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Cortes de caja",
        path: "/cortesdecaja",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "C",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Reimpresión de caja",
        path: "/reimpresioncaja",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "R",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Reporte de reposiciones",
        path: "/reporteventasalmacen",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Pago Comisiones",
        path: "/pagocomisiones",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Centro de Costos",
        path: "/centrocostos",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Control de Asistencias",
        path: "/controlasistencia",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Cuentas X Cobrar",
        path: "/cuentasxcobrar",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Nóminas",
        path: "/nominas",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Compras",
        path: "/compras",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Apartados",
        pagina: "Apartados admin",
        path: "/apartados",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "A",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Accesos",
        path: "/accesos",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Maestro artículos",
        path: "/articulos",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "M",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Almacenes Exhibidores",
        path: "/almacenesexhibidores",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Corridas",
        path: "/corridas",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Clientes",
        path: "/clientes",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Proveedores",
        path: "/proveedores",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
      {
        id: 1,
        menu: "Configuración",
        pagina: "Parámetros de estación",
        path: "/parametrosestacion",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
      },
      {
        id: 1,
        menu: "Configuración",
        pagina: "Ticket ventas master",
        path: "/parametrosticketmaster",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
      },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Entradas",
        path: "/entradas",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Etiquetado",
        path: "/etiquetado",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Existencias",
        path: "/existencias",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "E",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Salidas",
        path: "/salidas",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Traslados A o H",
        path: "/traslados",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "T",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Toma inventario",
        path: "/tomainventario",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Conteos de escaneo",
        path: "/conteosescaneo",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Conteos inicialización con foto",
        path: "/conteosinicializacionconfoto",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Devoluciones",
        path: "/devoluciones",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "T",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Preventas",
        path: "/preventas",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "P",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Venta súper",
        path: "/ventas",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "V",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Verificador",
        path: "/verificador",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "S",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Asistencia en piso",
        path: "/asistenciapiso",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Asistencia IA",
        pagina: "Entrenamiento IA",
        path: "/iaentrenamiento",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "I",
    },
    {
        id: 1,
        menu: "Sistema",
        pagina: "Registro de fallos",
        path: "/registrofallos",
        mostrar: true,
        tipousuario: "ADMINISTRADOR",
        hotkey: "",
    },
]);

export const getStructMenusAccesosSA = () => ([
    ...getStructMenusAccesosAdministrador().map((item) => ({
        ...item,
        tipousuario: "SA",
    })),
]);

export const getStructMenusAccesosSupervisor = () => ([
    {
        id: 1,
        menu: "Administración",
        pagina: "Devoluciones",
        path: "/devoluciones",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "D",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Cortes de caja",
        path: "/cortesdecaja",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Reimpresión de caja",
        path: "/reimpresioncaja",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "R",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Reporte de reposiciones",
        path: "/reporteventasalmacen",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Pago Comisiones",
        path: "/pagocomisiones",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Centro de Costos",
        path: "/centrocostos",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Control de Asistencias",
        path: "/controlasistencia",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Nóminas",
        path: "/nominas",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Compras",
        path: "/compras",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Cuentas X Cobrar",
        path: "/cuentasxcobrar",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Apartados",
        pagina: "Apartados admin",
        path: "/apartados",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "A",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Accesos",
        path: "/accesos",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Maestro artículos",
        path: "/articulos",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "M",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Clientes",
        path: "/clientes",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Proveedores",
        path: "/proveedores",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
      {
        id: 1,
        menu: "Configuración",
        pagina: "Parámetros de estación",
        path: "/parametrosestacion",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
      },
      {
        id: 1,
        menu: "Configuración",
        pagina: "Ticket ventas master",
        path: "/parametrosticketmaster",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
      },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Entradas",
        path: "/entradas",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Etiquetado",
        path: "/etiquetado",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Existencias",
        path: "/existencias",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "E",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Salidas",
        path: "/salidas",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Traslados A o H",
        path: "/traslados",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Toma inventario",
        path: "/tomainventario",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Conteos de escaneo",
        path: "/conteosescaneo",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Conteos inicialización con foto",
        path: "/conteosinicializacionconfoto",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Devoluciones",
        path: "/devoluciones",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Preventas",
        path: "/preventas",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "P",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Venta súper",
        path: "/ventas",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Verificador",
        path: "/verificador",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Asistencia en piso",
        path: "/asistenciapiso",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Asistencia IA",
        pagina: "Entrenamiento IA",
        path: "/iaentrenamiento",
        mostrar: false,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Sistema",
        pagina: "Registro de fallos",
        path: "/registrofallos",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
]);

export const getStructMenusAccesosVendedor = () => ([
    {
        id: 1,
        menu: "Administración",
        pagina: "Devoluciones",
        path: "/devoluciones",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Cortes de caja",
        path: "/cortesdecaja",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Reimpresión de caja",
        path: "/reimpresioncaja",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "R",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Reporte de reposiciones",
        path: "/reporteventasalmacen",
        mostrar: true,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Pago Comisiones",
        path: "/pagocomisiones",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Centro de Costos",
        path: "/centrocostos",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Control de Asistencias",
        path: "/controlasistencia",
        mostrar: true,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Nóminas",
        path: "/nominas",
        mostrar: true,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Compras",
        path: "/compras",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Apartados",
        pagina: "Apartados admin",
        path: "/apartados",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Accesos",
        path: "/accesos",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Maestro artículos",
        path: "/articulos",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Clientes",
        path: "/clientes",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Proveedores",
        path: "/proveedores",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
      {
        id: 1,
        menu: "Configuración",
        pagina: "Parámetros de estación",
        path: "/parametrosestacion",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
      },
      {
        id: 1,
        menu: "Configuración",
        pagina: "Ticket ventas master",
        path: "/parametrosticketmaster",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
      },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Entradas",
        path: "/entradas",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Etiquetado",
        path: "/etiquetado",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Existencias",
        path: "/existencias",
        mostrar: true,
        tipousuario: "VENDEDOR",
        hotkey: "E",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Salidas",
        path: "/salidas",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Traslados A o H",
        path: "/traslados",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "T",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Toma inventario",
        path: "/tomainventario",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Conteos de escaneo",
        path: "/conteosescaneo",
        mostrar: true,
        tipousuario: "SUPERVISOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Conteos inicialización con foto",
        path: "/conteosinicializacionconfoto",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Devoluciones",
        path: "/devoluciones",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "T",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Preventas",
        path: "/preventas",
        mostrar: true,
        tipousuario: "VENDEDOR",
        hotkey: "P",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Venta súper",
        path: "/ventas",
        mostrar: true,
        tipousuario: "VENDEDOR",
        hotkey: "V",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Verificador",
        path: "/verificador",
        mostrar: true,
        tipousuario: "VENDEDOR",
        hotkey: "S",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Asistencia en piso",
        path: "/asistenciapiso",
        mostrar: true,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Asistencia IA",
        pagina: "Entrenamiento IA",
        path: "/iaentrenamiento",
        mostrar: false,
        tipousuario: "VENDEDOR",
        hotkey: "",
    },
]);

export const getStructMenusAccesosNull = () => ([
    {
        id: 1,
        menu: "Administración",
        pagina: "Devoluciones",
        path: "/devoluciones",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Cortes de caja",
        path: "/cortesdecaja",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Reimpresión de caja",
        path: "/reimpresioncaja",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Pago Comisiones",
        path: "/pagocomisiones",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Centro de Costos",
        path: "/centrocostos",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Control de Asistencias",
        path: "/controlasistencia",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Nóminas",
        path: "/nominas",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Administración",
        pagina: "Compras",
        path: "/compras",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Apartados",
        pagina: "Apartados admin",
        path: "/apartados",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Accesos",
        path: "/accesos",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Maestro artículos",
        path: "/articulos",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Clientes",
        path: "/clientes",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Catálogos",
        pagina: "Proveedores",
        path: "/proveedores",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
      {
        id: 1,
        menu: "Configuración",
        pagina: "Parámetros de estación",
        path: "/parametrosestacion",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
      },
      {
        id: 1,
        menu: "Configuración",
        pagina: "Ticket ventas master",
        path: "/parametrosticketmaster",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
      },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Entradas",
        path: "/entradas",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Etiquetado",
        path: "/etiquetado",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Existencias",
        path: "/existencias",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "E",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Salidas",
        path: "/salidas",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Traslados A o H",
        path: "/traslados",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "T",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Toma inventario",
        path: "/tomainventario",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Conteos de escaneo",
        path: "/conteosescaneo",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Inventarios",
        pagina: "Conteos inicialización con foto",
        path: "/conteosinicializacionconfoto",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Devoluciones",
        path: "/devoluciones",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Preventas",
        path: "/preventas",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Venta súper",
        path: "/ventas",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Verificador",
        path: "/verificador",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Ventas",
        pagina: "Asistencia en piso",
        path: "/asistenciapiso",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
    {
        id: 1,
        menu: "Asistencia IA",
        pagina: "Entrenamiento IA",
        path: "/iaentrenamiento",
        mostrar: false,
        tipousuario: "USUARIO",
        hotkey: "",
    },
]);

export const AccesosContext = createContext();

const getTemplateRowsRaw = () => [
  ...getStructMenusAccesosSA(),
  ...getStructMenusAccesosAdministrador(),
  ...getStructMenusAccesosSupervisor(),
  ...getStructMenusAccesosVendedor(),
  ...getStructMenusAccesosNull(),
];

const systemLogPath = "/registrofallos";
const isSystemLogRow = (row = {}) => cleanText(row.path ?? row.Path) === systemLogPath;
const roleCanUseSystemLog = (rol) => ["SA", "ADMINISTRADOR", "SUPERVISOR"].includes(normalizeCompare(rol));

const getDefaultOrdenGrupo = (menu) => {
  const currentMenu = normalizeCompare(menu);
  if (!currentMenu) return 0;

  const menusOrdenados = [];
  getTemplateRowsRaw().forEach((item) => {
    const menuName = cleanText(item.menu);
    if (menuName && !menusOrdenados.some((x) => normalizeCompare(x) === normalizeCompare(menuName))) {
      menusOrdenados.push(menuName);
    }
  });

  const index = menusOrdenados.findIndex((item) => normalizeCompare(item) === currentMenu);

  return index >= 0 ? index + 1 : 0;
};

const normalizeOrdenGrupo = (value, menu) => {
  const orden = normalizeOrden(value, 0);
  return orden > 0 ? orden : getDefaultOrdenGrupo(menu);
};

const normalizeKey = (value) =>
  (value ?? "")
    .toString()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "")
    .slice(0, 1);

const buildRoleMap = (rol) => {
  const map = new Map();
  const rows = getRoleRows(rol);

  rows.forEach((item) => {
    const row = normalizeMenuRow(item, rol);
    map.set(menuPageKey(row.menu, row.pagina), row);
  });

  return map;
};

function mapMenusToTree(data) {
    const grouped = {};

    (data ?? []).forEach((item) => {
        const row = normalizeMenuRow(item);
        const menuName = row.menu;
        const pagina = row.pagina;
        const ordenGrupo = normalizeOrdenGrupo(row.ordenGrupo, menuName);

        if (!menuName || !pagina) return;

        if (!grouped[menuName]) {
        grouped[menuName] = {
            id: menuName,
            id2: `parent-${menuName}`,
            label: menuName,
            menu: menuName,
            mostrar: false,
            children: [],
        };
        }

        grouped[menuName].children.push({
        id: menuName,
        id2: `child-${menuName}-${pagina}`,
        menu: menuName,
        pagina: pagina,
        label: pagina,
        path: row.path,
        mostrar: !!row.mostrar,
        tipousuario: row.tipousuario,
        hotkey: row.hotkey,
        orden: row.orden,
        ordenGrupo,
        });
    });

    return Object.values(grouped).map((parent) => {
        const firstGrupo = (parent.children ?? []).find((c) => normalizeOrden(c.ordenGrupo, 0) > 0);
        return {
            ...parent,
            ordenGrupo: firstGrupo ? normalizeOrdenGrupo(firstGrupo.ordenGrupo, parent.menu || parent.label) : getDefaultOrdenGrupo(parent.menu || parent.label),
            mostrar: (parent.children ?? []).some((c) => !!c.mostrar),
            children: [...(parent.children ?? [])].sort(compareMenuNodes),
        };
    }).sort((a, b) => {
        const ordA = normalizeOrden(a?.ordenGrupo, 0);
        const ordB = normalizeOrden(b?.ordenGrupo, 0);
        if (ordA !== ordB) return ordA - ordB;
        return cleanText(a?.label).localeCompare(cleanText(b?.label), 'es');
    });
}

const buildMenusTree = (backendRows = [], rol = "USUARIO") => {
  const roleMap = buildRoleMap(rol);

  const backendMap = new Map();
  (backendRows ?? []).forEach((item) => {
    const row = normalizeMenuRow(item, rol);
    backendMap.set(menuPageKey(row.menu, row.pagina), row);
  });

  const schemaRows = getAllTemplateRows();
  const fullRows = schemaRows.map((master) => {
    const key = menuPageKey(master.menu, master.pagina);

    const fromBackend = backendMap.get(key);
    const fromRole = roleMap.get(key);

    return {
      menu: cleanText(master.menu),
      pagina: cleanText(master.pagina),
      path: cleanText(fromBackend?.path || fromRole?.path || master.path),
      mostrar: isSystemLogRow(master) && !roleCanUseSystemLog(rol) ? false : (fromBackend ? !!fromBackend.mostrar : !!(fromRole?.mostrar ?? false)),
      tipousuario: cleanText(fromBackend?.tipousuario || fromRole?.tipousuario || rol || "USUARIO"),
      hotkey: cleanText(fromBackend?.hotkey || fromRole?.hotkey).toUpperCase().slice(0, 1),
      orden: normalizeOrden(fromBackend?.orden ?? fromRole?.orden, getDefaultOrden(master.menu, master.path, master.pagina)),
      ordenGrupo: normalizeOrdenGrupo(fromBackend?.ordenGrupo ?? fromRole?.ordenGrupo, master.menu),
    };
  });

  return mapMenusToTree(fullRows);
};

const deepClone = (x) => JSON.parse(JSON.stringify(x));

const cleanText = (value) => (value ?? "").toString().trim();

const normalizeCompare = (value) =>
  cleanText(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase();

const menuPageKey = (menu, pagina) =>
  `${normalizeCompare(menu)}|${normalizeCompare(pagina)}`;

const getDefaultOrden = (menu, path, pagina) => {
  const currentMenu = normalizeCompare(menu);
  const currentPath = cleanText(path);
  const currentPagina = normalizeCompare(pagina);
  const rows = getTemplateRowsRaw().filter((item) => normalizeCompare(item.menu) === currentMenu);
  const index = rows.findIndex((item) =>
    cleanText(item.path) === currentPath || normalizeCompare(item.pagina) === currentPagina
  );

  return index >= 0 ? index + 1 : 0;
};

const normalizeOrden = (value, fallback = 0) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed < 0) return fallback;
  return parsed;
};

const compareMenuNodes = (a, b) => {
  const orderA = normalizeOrden(a?.orden ?? a?.Orden, Number.MAX_SAFE_INTEGER);
  const orderB = normalizeOrden(b?.orden ?? b?.Orden, Number.MAX_SAFE_INTEGER);

  if (orderA !== orderB) return orderA - orderB;

  return cleanText(a?.label ?? a?.pagina).localeCompare(cleanText(b?.label ?? b?.pagina), "es");
};

const normalizeMenuRow = (row, rolDefault = "USUARIO") => {
  const menu = cleanText(row?.menu ?? row?.Menu);
  const pagina = cleanText(row?.pagina ?? row?.Pagina ?? row?.label);
  const path = cleanText(row?.path ?? row?.Path);

  return {
    id: row?.id ?? row?.ID ?? 0,
    menu,
    pagina,
    path,
    mostrar: !!(row?.mostrar ?? row?.Mostrar),
    tipousuario: cleanText(row?.tipousuario ?? rolDefault),
    hotkey: cleanText(row?.hotkey).toUpperCase().slice(0, 1),
    orden: normalizeOrden(row?.orden ?? row?.Orden, getDefaultOrden(menu, path, pagina)),
    ordenGrupo: normalizeOrdenGrupo(row?.ordenGrupo ?? row?.ordengrupo ?? row?.OrdenGrupo, menu),
  };
};

const getRoleRows = (rol) => {
  const r = normalizeCompare(rol);

  if (r === "SA") return getStructMenusAccesosSA();
  if (r === "ADMINISTRADOR") return getStructMenusAccesosAdministrador();
  if (r === "SUPERVISOR") return getStructMenusAccesosSupervisor();
  if (r === "VENDEDOR") return getStructMenusAccesosVendedor();

  return getStructMenusAccesosNull();
};

const getAllTemplateRows = () => {
  const all = getTemplateRowsRaw();

  const map = new Map();

  all.forEach((item) => {
    const row = normalizeMenuRow(item);
    const key = menuPageKey(row.menu, row.pagina);

    if (!map.has(key)) {
      map.set(key, {
        id: row.id,
        menu: row.menu,
        pagina: row.pagina,
        path: row.path,
        mostrar: false,
        tipousuario: row.tipousuario || "USUARIO",
        hotkey: row.hotkey || "",
        orden: row.orden,
        ordenGrupo: row.ordenGrupo,
      });
    }
  });

  return Array.from(map.values());
};

const unwrapMenuRows = (result) => {
  if (Array.isArray(result)) return result;
  if (Array.isArray(result?.menumodel ?? result?.MenuModel)) return result.menumodel ?? result.MenuModel;
  return [];
};

const integrateTreeToRows = (tree = [], rol = "USUARIO") => {
  const rows = [];

  (tree ?? []).forEach((parent) => {
    (parent.children ?? []).forEach((child) => {
      rows.push({
        id: 0,
        menu: cleanText(parent.menu || parent.label),
        pagina: cleanText(child.pagina || child.label),
        path: cleanText(child.path),
        mostrar: !!child.mostrar,
        tipousuario: cleanText(child.tipousuario || rol || "USUARIO"),
        hotkey: cleanText(child.hotkey).toUpperCase().slice(0, 1),
        orden: normalizeOrden(child.orden),
        ordengrupo: normalizeOrden(child.ordenGrupo),
      });
    });
  });

  return rows;
};

const mergeSchemaWithRows = (schemaRows = [], dataRows = [], rol = "USUARIO") => {
  const dataMap = new Map();

  (dataRows ?? []).forEach((item) => {
    const row = normalizeMenuRow(item, rol);
    dataMap.set(menuPageKey(row.menu, row.pagina), row);
  });

  return (schemaRows ?? []).map((item) => {
    const schema = normalizeMenuRow(item, rol);
    const found = dataMap.get(menuPageKey(schema.menu, schema.pagina));

    return {
      id: found?.id ?? schema.id ?? 0,
      menu: schema.menu,
      pagina: schema.pagina,
      path: cleanText(found?.path || schema.path),
      mostrar: isSystemLogRow(schema) && !roleCanUseSystemLog(rol) ? false : (found ? !!found.mostrar : !!schema.mostrar),
      tipousuario: cleanText(found?.tipousuario || schema.tipousuario || rol || "USUARIO"),
      hotkey: cleanText(found?.hotkey || schema.hotkey).toUpperCase().slice(0, 1),
      orden: normalizeOrden(found?.orden ?? schema.orden, getDefaultOrden(schema.menu, schema.path, schema.pagina)),
      ordenGrupo: normalizeOrdenGrupo(found?.ordenGrupo ?? schema.ordenGrupo, schema.menu),
    };
  });
};

const buildTreeFromTemplate = (templateRows = [], rol = "USUARIO") => {
  const schema = getAllTemplateRows();
  const completed = mergeSchemaWithRows(schema, templateRows, rol);
  return mapMenusToTree(completed);
};

const matchNode = (node, nodeId) => {
  const id = String(nodeId ?? "");
  return (
    String(node?.id2 ?? "") === id ||
    String(node?.id ?? "") === id ||
    String(node?.path ?? "") === id ||
    String(node?.label ?? "") === id
  );
};

const matchChild = (child, nodeId) => {
  const id = String(nodeId ?? "");
  return (
    String(child?.id2 ?? "") === id ||
    String(child?.id ?? "") === id ||
    String(child?.path ?? "") === id ||
    String(child?.label ?? "") === id
  );
};

const normalizeHotkey = (value) =>
  cleanText(value).toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 1);

export const AccesosProvider = (props) => {
    const navigation = useNavigate();
    const [statusNuevo, setStatusNuevo] = useState(true);

    const {usuarioData, handleRecargarMenuSesion} = useSesion();
    
    const [usuarios, setUsuarios] = useState([]);
    const [usuarioActual, setUsuarioActual] = useState(getStructAccesosDefault());
    const [menus, setMenus] = useState([]);
    const [menusAccesos, setMenusAccesos] = useState([]);

    const [permisos, setPermisos] = useState([]);
    const [usuarioSeleccionado, setUsuarioSeleccionado] = useState({});
    const [rolSeleccionado, setRolSeleccionado] = useState("");
    const roles = ["SA", "ADMINISTRADOR", "SUPERVISOR", "VENDEDOR", "USUARIO"];
    const [statusEnableFields, setStatusEnableFields] = useState(true);
    const [statusCanEdit, setStatusCanEdit] = useState(false);
    const [tabIndex, setTabIndex] = useState(0);
    const [alcances, setAlcances] = useState([]); 
    const [modalOpenEliminarAcceso, setModalOpenEliminarAcceso] = useState(false);
    
    const [accesoPayLoad, setAccesoPayLoad] = useState(getStructAccesoPayload()); 

     // Para detectar cambios y poder revertir
    const [snapshotUsuario, setSnapshotUsuario] = useState(getStructAccesos());
    const [snapshotMenus, setSnapshotMenus] = useState([]);
    const [snapshotPerm, setSnapshotPerm] = useState([]);
    const [snapshotAlc, setSnapshotAlc] = useState([]);

    const guardarAccesoRef = useRef(false);
    const eliminarAccesoRef = useRef(false);

    const normalizeUsuario = (u) => {
        const x = u ?? {};
        const trim = (v) => (typeof v === "string" ? v.trim() : v);

        return {
            id: x.id ?? 0,
            fecharegistro: x.fecharegistro ?? null,

            usuario: trim(x.usuario ?? ""),
            nombreusuario: trim(x.nombreusuario ?? ""),
            password: trim(x.password ?? ""),
            clavesecreta: trim(x.clavesecreta ?? ""),

            direccion: trim(x.direccion ?? ""),
            coloniacomunidad: trim(x.coloniacomunidad ?? ""),
            delegacionmunicipio: trim(x.delegacionmunicipio ?? ""),
            ciudadpoblacion: trim(x.ciudadpoblacion ?? ""),
            cp: trim(x.cp ?? ""),

            telefono: trim(x.telefono ?? ""),
            email: trim(x.email ?? ""),
            puesto: trim(x.puesto ?? ""),
            tipousuario: trim(x.tipousuario ?? ""),
            roles: trim(x.roles ?? ""),

            alcance: Number(x.alcance ?? 0),
            statuscomision: !!x.statuscomision,
            comisionventa: Number(x.comisionventa ?? 0),

            adicional: trim(x.adicional ?? ""),
            foto: x.foto ?? "",
        };
    };

    const dirty = useMemo(() => {
        return (
            JSON.stringify(menusAccesos) !== JSON.stringify(snapshotMenus) ||
            JSON.stringify(permisos) !== JSON.stringify(snapshotPerm) ||
            JSON.stringify(alcances) !== JSON.stringify(snapshotAlc) ||
            JSON.stringify(normalizeUsuario(usuarioActual)) !== JSON.stringify(normalizeUsuario(snapshotUsuario))
        );
    }, [menusAccesos, menus, permisos, alcances, usuarioActual, snapshotMenus, snapshotPerm, snapshotAlc, snapshotUsuario]);

    const { handleOpenAlert } = useLayout();

    const { GetRequest, PutRequest, DeleteRequest } = useRequest();

    const aplicarValidacionCoincidencia = (payload, campo, confirmacion, mensaje) => {
        const valorCampo = payload?.[campo]?.value ?? "";
        const valorConfirmacion = payload?.[confirmacion]?.value ?? "";
        const tieneDatos = String(valorCampo).length > 0 || String(valorConfirmacion).length > 0;
        const noCoincide = tieneDatos && valorCampo !== valorConfirmacion;
        const campoTieneErrorCoincidencia = payload[campo]?.helper === mensaje;
        const confirmacionTieneErrorCoincidencia = payload[confirmacion]?.helper === mensaje;

        return {
            ...payload,
            [campo]: {
                ...payload[campo],
                error: noCoincide ? true : campoTieneErrorCoincidencia ? false : payload[campo]?.error ?? false,
                helper: noCoincide ? mensaje : campoTieneErrorCoincidencia ? "" : payload[campo]?.helper ?? "",
            },
            [confirmacion]: {
                ...payload[confirmacion],
                error: noCoincide ? true : confirmacionTieneErrorCoincidencia ? false : payload[confirmacion]?.error ?? false,
                helper: noCoincide ? mensaje : confirmacionTieneErrorCoincidencia ? "" : payload[confirmacion]?.helper ?? "",
            },
        };
    };

    const validarCoincidenciasAccesoPayload = (payload) => {
        let result = payload;

        result = aplicarValidacionCoincidencia(
            result,
            "password",
            "confirmacion",
            "La confirmación del Password no coincide"
        );

        result = aplicarValidacionCoincidencia(
            result,
            "clavesecreta",
            "confirmacionclavesecreta",
            "La confirmación de la Clave secreta no coincide"
        );

        return result;
    };

    const HandleCargarUsuarios = async () => {
        const result = await GetRequest({
            url: apiAccesosList,
            loader: "Se está solicitando la lista de accesos al sistema",
        });

        if (result.hasError) {
            handleOpenAlert("Error al obtener la lista de accesos: " + result.message);
            return;
        }

        let data = result?.result;

        if (data && !Array.isArray(data)) {
            data = Object.keys(data)
            .filter(k => !isNaN(k))   
            .map(k => data[k]);
        }

        setUsuarios(data ?? []);
        return data ?? [];
    };

    const handleCargarMenus = async (userId) => {
        if (!userId) return;

        const result = await GetRequest({
            url: apiMenusListaUsuario.replace("{idusuario}", userId),
            loader: "Se está cargando la lista de menus del usuario..."
        });

        if (result.hasError) {
            handleOpenAlert("Error al cargar lista de menú's asignados del usuario: " + result.message);
            return;
        }

        setMenus(mapMenusToTree(result?.result));
    };

    const cargarDefinicionMenu = (menumodal, tipouser) => { //Método original para cargar la definición de menú al arranar sistema
        const rows = Array.isArray(menumodal)
        ? menumodal
        : (menumodal?.MenuModel ?? []);

        const definicionMenus = {
        _paths: [],
        _paginas: [], // si no lo usas, lo puedes quitar
        };

        const T = (s) => (s ?? "").toString().trim();

        for (const menu of rows) {
        const Menu = T(menu.Menu);
        const Pagina = T(menu.Pagina);
        const Path = T(menu.Path);
        const Mostrar = !!menu.Mostrar;
        const tipo = T(menu.tipousuario);
        const hotkey = T(menu.hotkey);

        if (!Menu || !Pagina) continue;

        if (!definicionMenus[Menu]) {
            definicionMenus[Menu] = {
            nombre: Menu,
            tipousuario: tipo,
            mostrar: false,     // 🔥 se recalcula al final
            _paginas: {},
            };
        }

        // tu lógica de status (la dejé equivalente pero más legible)
        const bloqueado = ["SA", "ADMINISTRADOR", "SUPERVISOR"].includes(tipo) ? false : (tipo !== tipouser);

        definicionMenus[Menu]._paginas[Pagina] = {
            nombre: Pagina,
            path: Path,
            mostrar: Mostrar,
            tipousuario: tipo,
            status: bloqueado,
            hotkey,
        };

        definicionMenus._paths.push({ [Menu]: Path });
        }

        // 🔥 PADRE = OR de sus páginas
        Object.keys(definicionMenus).forEach((k) => {
        if (k.startsWith("_")) return;
        const paginas = Object.values(definicionMenus[k]._paginas ?? {});
        definicionMenus[k].mostrar = paginas.some((p) => !!p.mostrar);
        });

        setMenusAccesos(definicionMenus);
    };

    const handleToggleMenu = (menu) => {
        const updated = menus.map(m =>
            m.id === menu.id ? { ...m, mostrar: !m.mostrar } : m
        );
        setMenus(updated);
    };

    const handleChangeTab = (event, newValue) => {
        setTabIndex(newValue);
    };

    const [selectedMenus, setSelectedMenus] = useState([]);
    const handleChangeTreeView = (selectedId) => {
        setSelectedMenus(selectedId);
    };

    const handleChangeMenusStatus = (nodeId, nuevoStatus) => {
        if (statusEnableFields) return;

        setMenusAccesos((prev) =>
            (prev ?? []).map((parent) => {
                const isParent = matchNode(parent, nodeId);

                if (isParent) {
                    const children = (parent.children ?? []).map((child) => ({
                        ...child,
                        mostrar: !!nuevoStatus,
                    }));

                    return {
                        ...parent,
                        mostrar: !!nuevoStatus,
                        children,
                    };
                }

                const children = (parent.children ?? []).map((child) =>
                    matchNode(child, nodeId)
                    ? { ...child, mostrar: !!nuevoStatus }
                    : child
                );

                return {
                    ...parent,
                    children,
                    mostrar: children.some((x) => !!x.mostrar),
                };
            })
        );
    };

    const integrateTreeToRows = (tree = [], rol = "USUARIO") => {
        const rows = [];

        (tree ?? []).forEach((parent) => {
            (parent.children ?? []).forEach((child) => {
                rows.push({
                    id: 0,
                    menu: cleanText(parent.menu || parent.label),
                    pagina: cleanText(child.pagina || child.label),
                    path: cleanText(child.path),
                    mostrar: !!child.mostrar,
                    tipousuario: cleanText(child.tipousuario || rol || "USUARIO"),
                    hotkey: cleanText(child.hotkey).toUpperCase().slice(0, 1),
                    orden: normalizeOrden(child.orden),
                    ordengrupo: normalizeOrden(child.ordenGrupo),
                });
            });
        });

        return rows;
    };

    const handleAplicarRol = (rol) => {
        if (statusEnableFields) return;

        const r = cleanText(rol || "USUARIO").toUpperCase();

        setRolSeleccionado(r);
        setUsuarioActual((prev) => ({
            ...prev,
            tipousuario: r,
        }));
        setAccesoPayLoad((prev) => ({
            ...prev,
            tipousuario: { ...prev.tipousuario, value: r },
        }));

        const templateRows = getRoleRows(r);
        const tree = buildTreeFromTemplate(templateRows, r);

        setMenusAccesos(tree);
    };

    const handleChangeDataAccesoPayload = (e, valor, field) => {
        let name = field ? field : e.target.name ?? "";
        let value = valor !== undefined ? valor : e.target.value ?? "";
        let error = false;
        let helper = "";

        const mensajeError = handleValidarStrings(value, name);
        if (mensajeError) {
            error = true;
            helper = mensajeError;
        }

        const lower = String(value).toLowerCase();
        if (!error && (
            lower.includes("<script") ||
            lower.includes("</script") ||
            lower.includes("javascript:") ||
            lower.includes("onerror=") ||
            lower.includes("onload=")
        )) {
            error = true;
            helper = "Intento de inyección detectado y bloqueado";
        }

        setAccesoPayLoad(prev => {
            const nextPayload = {
                ...prev,
                [name]: { ...prev[name], value, error, helper },
            };

            return validarCoincidenciasAccesoPayload(nextPayload);
        });

        setUsuarioActual(prev => ({ ...prev, [name]: value }));
    };

    const handleObtenerPermisos = async (userId) => {
        if (!userId) return;

        const r = await GetRequest({
            url: apiAccesosPermisos.replace("{idusuario}", userId),
            loader: "Cargando permisos...",
        });

        if (r?.hasError) {
            handleOpenAlert("Error al cargar permisos: " + r.message);
            return false;
        }

        // Esperado: [{ iduser, modulo, status }]
        const data = (r?.result ?? []).map((p) => ({
            iduser: p.iduser ?? userId,
            modulo: (p.modulo ?? "").trim(),
            status: p.status === true || p.status === 1 || p.status === "1" || p.status === "true" ? 1 : 0,
        }));

        setPermisos(data);
        setSnapshotPerm(deepClone(data));
        return true;
    };

    const handleObtenerAlcances = async (idAcceso) => {
        if (!idAcceso) return;

        const r = await GetRequest({
            url: apiAccesosAlcances.replace("{idusuario}", idAcceso),
            loader: "Cargando alcances...",
        });
        
        if (r?.hasError) {
            handleOpenAlert("Error al cargar alcances: " + r.message);
            return false;
        }

        // Esperado: [{ usuario, alcance, idacceso? / id? }]
        const data = (r?.result ?? []).map((a) => ({
            usuario: (a.usuario ?? usuarioActual.usuario ?? "").trim(),
            alcance: (a.alcance ?? "").trim(),
            id: a.idacceso ?? idAcceso,
        }));

        setAlcances(data);
        setSnapshotAlc(deepClone(data));
        return true;
    };

    const handleObtenerMenus = async (idAcceso, preserveOrder = null) => {
        if (!idAcceso) return;

        const r = await GetRequest({
            url: apiAccesosMenus.replace("{idusuario}", idAcceso),
            loader: "Cargando menús...",
        });

        if (r?.hasError) {
            handleOpenAlert("Error al cargar menús: " + r.message);
            return false;
        }

        const rows = unwrapMenuRows(r?.result);
        const rolAcceso = usuarioActual?.tipousuario || "USUARIO";
        const llaveCreditoClientes = menuPageKey("Administración", "Cuentas X Cobrar");
        const existeCreditoClientes = rows.some((row) =>
            menuPageKey(row?.menu ?? row?.Menu, row?.pagina ?? row?.Pagina ?? row?.label) === llaveCreditoClientes
        );
        const menuCreditoClientes = getRoleRows(rolAcceso).find((row) =>
            menuPageKey(row.menu, row.pagina) === llaveCreditoClientes
        );
        const rowsCompletos = !existeCreditoClientes && menuCreditoClientes
            ? [...rows, menuCreditoClientes]
            : rows;
        let tree = mapMenusToTree(rowsCompletos);

        if (preserveOrder && preserveOrder.size > 0) {
            tree = tree.map((parent) => {
                const parentKey = cleanText(parent.menu || parent.label);
                const savedParent = preserveOrder.get(parentKey);
                if (!savedParent) return parent;

                const children = (parent.children ?? []).map((child) => {
                    const childKey = cleanText(child.pagina || child.label);
                    const savedChild = savedParent.childrenMap.get(childKey);
                    return savedChild
                        ? { ...child, ordenGrupo: savedChild.ordenGrupo, orden: savedChild.orden }
                        : child;
                });

                return { ...parent, ordenGrupo: savedParent.ordenGrupo, children };
            });
        }

        setMenus(tree);
        setMenusAccesos(tree);
        setSnapshotMenus(deepClone(tree));
        return true;
    };

    const integrateIDtoMenusForSave = (idUser) => {
        const out = [];

        (menusAccesos ?? []).forEach((parent) => {
            (parent.children ?? []).forEach((child) => {
                out.push({
                    id: idUser,
                    menu: cleanText(parent.menu || parent.label),
                    pagina: cleanText(child.pagina || child.label),
                    path: cleanText(child.path),
                    mostrar: !!child.mostrar,
                    tipousuario: cleanText(child.tipousuario || rolSeleccionado || usuarioActual?.tipousuario || "USUARIO"),
                    hotkey: cleanText(child.hotkey).toUpperCase().slice(0, 1),
                    orden: normalizeOrden(child.orden),
                    ordengrupo: normalizeOrden(child.ordenGrupo),
                });
            });
        });

        return out;
    };

    const handleHotKeyChange = (nodeId, value) => {
        if (statusEnableFields) return;

        const key = normalizeHotkey(value);

        setMenusAccesos((prev) => {
            return (prev ?? []).map((parent) => {
                const childrenWithoutDuplicate = (parent.children ?? []).map((child) => {
                    const isTarget = matchChild(child, nodeId);
                    const shouldClear = key && child.hotkey === key && !isTarget;
                    return shouldClear ? { ...child, hotkey: "" } : child;
                });

                const children = childrenWithoutDuplicate.map((child) => {
                    if (!matchChild(child, nodeId)) return child;
                    return { ...child, hotkey: key };
                });

                return { ...parent, children };
            });
        });
    };

    const handleReordenMenus = (parentId, sourceId, targetId) => {
        if (statusEnableFields) return;
        if (!parentId || !sourceId || !targetId || sourceId === targetId) return;

        const reorderTree = (tree = []) => {
            return (tree ?? []).map((parent) => {
                if (!matchNode(parent, parentId)) return parent;

                const children = [...(parent.children ?? [])];
                const sourceIndex = children.findIndex((child) => matchChild(child, sourceId));
                const targetIndex = children.findIndex((child) => matchChild(child, targetId));

                if (sourceIndex < 0 || targetIndex < 0) return parent;

                const [moving] = children.splice(sourceIndex, 1);
                children.splice(targetIndex, 0, moving);

                const reorderedChildren = children.map((child, index) => ({
                    ...child,
                    orden: index + 1,
                }));

                return {
                    ...parent,
                    children: reorderedChildren,
                    mostrar: reorderedChildren.some((child) => !!child.mostrar),
                };
            });
        };

        setMenusAccesos((prev) => reorderTree(prev));
        setMenus((prev) => reorderTree(prev));
    };

    const handleReordenMenusPadres = (sourceId, targetId) => {
        if (statusEnableFields) return;
        if (!sourceId || !targetId || sourceId === targetId) return;

        const reorderTree = (tree = []) => {
            const arr = [...(tree ?? [])];
            const srcIdx = arr.findIndex((p) => matchNode(p, sourceId));
            const tgtIdx = arr.findIndex((p) => matchNode(p, targetId));
            if (srcIdx < 0 || tgtIdx < 0 || srcIdx === tgtIdx) return tree;

            const [moved] = arr.splice(srcIdx, 1);
            arr.splice(tgtIdx, 0, moved);

            return arr.map((parent, idx) => {
                const children = (parent.children ?? []).map((child) => ({
                    ...child,
                    ordenGrupo: idx + 1,
                }));
                return {
                    ...parent,
                    ordenGrupo: idx + 1,
                    children,
                };
            });
        };
        setMenusAccesos((prev) => reorderTree(prev));
        setMenus((prev) => reorderTree(prev));
    };

    const sanitizeForApi = (value) => {
        if (value == null) return "";
        const str = String(value);
        return str
            .replace(/[<>'"`;\\]/g, "")
            .replace(/--/g, "")
            .replace(/xp_/gi, "")
            .replace(/exec\s/gi, "")
            .replace(/execute\s/gi, "")
            .replace(/script/gi, "")
            .replace(/javascript:/gi, "")
            .trim();
    };

    const handleGuardarCambiosUsuario = async () => {
        if (guardarAccesoRef.current) return false;
        guardarAccesoRef.current = true;

        try {
            if (isErrorForm(accesoPayLoad)) {
                handleOpenAlert("Existen errores en los datos del acceso y no es posible continuar!");
                return false;
            }

            const payloadValidadoCoincidencias = validarCoincidenciasAccesoPayload(accesoPayLoad);
            const passwordNoCoincide = payloadValidadoCoincidencias.password?.error || payloadValidadoCoincidencias.confirmacion?.error;
            const claveSecretaNoCoincide = payloadValidadoCoincidencias.clavesecreta?.error || payloadValidadoCoincidencias.confirmacionclavesecreta?.error;

            if (passwordNoCoincide) {
                setAccesoPayLoad(payloadValidadoCoincidencias);
                handleOpenAlert("La confirmación del 'Password' no coincide");
                return false;
            }

            if (claveSecretaNoCoincide) {
                setAccesoPayLoad(payloadValidadoCoincidencias);
                handleOpenAlert("La confirmación de la 'Clave secreta' no coincide");
                return false;
            }

            let idUser = usuarioActual?.id ?? 0;
            const usuarioStr = sanitizeForApi(usuarioActual?.usuario ?? "").toString().trim();

            const resultPayload = {};
            Object.entries(accesoPayLoad).forEach(([key, meta]) => {
                if (meta && typeof meta === "object" && "value" in meta) {
                    resultPayload[key] = sanitizeForApi(meta.value);
                } else {
                    resultPayload[key] = sanitizeForApi(meta);
                }
            });

            const payloadAcceso = {
                ...resultPayload,
                id: idUser,
                fecharegistro: usuarioActual.fecharegistro ?? getDatePost(),
                idUsuarioCreacion: usuarioData.id,
                idUsuarioModificacion: usuarioData.id,
                idUsuarioBaja: 0,
                foto: normalizarFotoParaApi(usuarioActual?.foto),
                statuscomision: usuarioActual.statuscomision ?? false,
                comisionventa: usuarioActual.comisionventa ?? 0,
            };

            const rAcceso = await PutRequest({
                url: apiAccesosGuardar, 
                body: payloadAcceso,            
                loader: "Guardando datos del acceso...",
            });

            if (rAcceso.hasError) {
                handleOpenAlert("Error al guardar datos del acceso: " + rAcceso.message);
                return false;
            }   

            idUser = rAcceso?.result?.id ?? rAcceso?.result?.ID ?? idUser;
            setUsuarioActual(prev => ({ ...prev, id: idUser, isNuevo: false }));

            const payloadMenus = integrateIDtoMenusForSave(idUser);
    
            const payloadPermisos = (permisos ?? []).map((h) => ({
                iduser: idUser,
                modulo: h.modulo,
                status: h.status ? 1 : 0,
            }));

            const payloadAlcances = (alcances ?? []).map((a) => ({
                usuario: usuarioStr,
                alcance: a.alcance,
                id: idUser,
            }));

            const rMenus = await PutRequest({
                url: apiMenusGuardarUsuario,
                body: payloadMenus,
                loader: "Guardando menús...",
            });

            const rPerm = await PutRequest({
                url: apiPermisosGuardarUsuario,
                body: payloadPermisos,
                loader: "Guardando permisos...",
            });

            const rAlc = await PutRequest({
                url: apiAlcancesGuardarUsuario,
                body: payloadAlcances,
                loader: "Guardando alcances...",
            });

            hadleChangeStatusNuevo(false);

            const usuarioSnapshot = { ...usuarioActual, id: idUser, isNuevo: false };

            setUsuarioActual(usuarioSnapshot);
            setSnapshotUsuario(deepClone(usuarioSnapshot));
            setSnapshotMenus(deepClone(menusAccesos));
            setSnapshotPerm(deepClone(permisos));
            setSnapshotAlc(deepClone(alcances));

            const preserveMenuOrder = new Map();
            (menusAccesos ?? []).forEach((parent) => {
                const pKey = cleanText(parent.menu || parent.label);
                const childrenMap = new Map();
                (parent.children ?? []).forEach((child) => {
                    const cKey = cleanText(child.pagina || child.label);
                    childrenMap.set(cKey, { ordenGrupo: child.ordenGrupo, orden: child.orden });
                });
                preserveMenuOrder.set(pKey, { ordenGrupo: parent.ordenGrupo, childrenMap });
            });

            await HandleCargarUsuarios();
            await handleCargarAccesoData(idUser);
            await handleObtenerMenus(idUser, preserveMenuOrder);
            await handleObtenerPermisos(idUser);
            await handleObtenerAlcances(idUser);
            if (handleRecargarMenuSesion) {
                await handleRecargarMenuSesion(usuarioData?.id, usuarioActual?.tipousuario);
            }
            handleOpenAlert("Cambios guardados", "ok");
            return true;
        } finally {
            guardarAccesoRef.current = false;
        }
    };

    const normalizarFotoParaApi = (foto) => {
        if (!foto) return ""; // evita null/undefined
        const s = String(foto).trim();
        if (s.startsWith("data:image")) {
            return s.split(",")[1] ?? "";
        }
        return s;
    };

    const handleCargarAccesoData = async (idUsuario) => {
        if (!idUsuario) return false;

        const r = await GetRequest({
            url: apiAccesosData.replace("{idusuario}", idUsuario),
            loader: "Cargando datos del usuario...",
        });

        if (r?.hasError) {
            handleOpenAlert("Error al cargar datos del usuario: " + r.message);
            return false;
        }

        const usuarioLoaded = {
            ...getStructAccesosDefault(),
            ...(r?.result ?? {}),
            isNuevo: false,
            foto: r?.result?.foto ?? "",
            confirmacion: r?.result?.password ?? "",
            confirmacionclavesecreta: r?.result?.clavesecreta ?? "",
            comisionventa: Number(r?.result?.comisionventa ?? 0),
        };

        setUsuarioActual(usuarioLoaded);

        const payloadLoaded = getStructAccesoPayload();
        Object.keys(payloadLoaded).forEach((key) => {
            if (usuarioLoaded[key] !== undefined) {
                const val = usuarioLoaded[key];
                if (typeof val === "number" || typeof val === "boolean") {
                    payloadLoaded[key] = { value: val, error: false, helper: "" };
                } else {
                    payloadLoaded[key] = { value: val ?? "", error: false, helper: "" };
                }
            }
        });
        setAccesoPayLoad(payloadLoaded);

        setSnapshotUsuario(deepClone(usuarioLoaded));
        setStatusCanEdit(true);
        return true;
    };

    const handleChangeDataAccesos = async (event, newValue) => {
        let idusuario = 0;

        if (!newValue) {
            setStatusNuevo(true);
            setUsuarioActual(getStructAccesosDefault());
            setAccesoPayLoad(getStructAccesoPayload());
            setMenus([]); setMenusAccesos([]); setPermisos([]); setAlcances([]);
            setStatusEnableFields(true);
            setStatusCanEdit(false);
            return;
        }

        if (typeof newValue === "object" && newValue.id) {
            idusuario = newValue.id;
        } else {
            const found = (usuarios ?? []).find((u) => u.usuario === newValue);
            idusuario = found?.id ?? 0;
        }

        if (!idusuario) return;

        setStatusEnableFields(true);
        setStatusCanEdit(true);

        setMenus([]); 
        setMenusAccesos([]);
        setPermisos([]); 
        setAlcances([]);

        await new Promise(resolve => setTimeout(resolve, 0));

        const okData = await handleCargarAccesoData(idusuario);
        if (!okData) return;

        const okMenus = await handleObtenerMenus(idusuario);
        if (!okMenus) return;

        await handleObtenerPermisos(idusuario);
        await handleObtenerAlcances(idusuario);
        
        setStatusNuevo(false);
    };

    const handleRevertirCambios = () => {
        setUsuarioActual(deepClone(snapshotUsuario));
        setMenus(deepClone(snapshotMenus));
        setMenusAccesos(deepClone(snapshotMenus));
        setPermisos(deepClone(snapshotPerm));
        setAlcances(deepClone(snapshotAlc));
        
        const payloadRevertido = getStructAccesoPayload();
        Object.keys(payloadRevertido).forEach((key) => {
            if (snapshotUsuario[key] !== undefined) {
                const val = snapshotUsuario[key];
                if (typeof val === "number" || typeof val === "boolean") {
                    payloadRevertido[key] = { value: val, error: false, helper: "" };
                } else {
                    payloadRevertido[key] = { value: val ?? "", error: false, helper: "" };
                }
            }
        });
        setAccesoPayLoad(payloadRevertido);
        
        handleOpenAlert("Cambios revertidos.");
    };

    const resetFormularioAccesos = () => {
        const defaultRol = "USUARIO";
        const defaultUser = {
            ...getStructAccesosDefault(),
            tipousuario: defaultRol,
        };
        const defaultTree = buildTreeFromTemplate(getRoleRows(defaultRol), defaultRol);

        setUsuarioActual(defaultUser);
        setAccesoPayLoad(getStructAccesoPayload());
        setRolSeleccionado("");
        setMenus(defaultTree);
        setMenusAccesos(defaultTree);
        setPermisos([]);
        setAlcances([]);
        setStatusNuevo(true);
        setStatusEnableFields(true);
        setStatusCanEdit(false);

        setSnapshotUsuario(deepClone(defaultUser));
        setSnapshotMenus(deepClone(defaultTree));
        setSnapshotPerm([]);
        setSnapshotAlc([]);
    };

    const handleDeshacer = () => {
        resetFormularioAccesos();
        handleOpenAlert("Formulario reinicializado.", "ok");
    };

    const handleOpenEliminarAcceso = () => {
        if (!usuarioActual?.id || usuarioActual?.isNuevo) {
            handleOpenAlert("Seleccione un acceso existente para eliminar.");
            return;
        }

        if (dirty) {
            handleOpenAlert("Guarde o revierta los cambios antes de eliminar el acceso.");
            return;
        }

        setModalOpenEliminarAcceso(true);
    };

    const handleCloseEliminarAcceso = () => {
        setModalOpenEliminarAcceso(false);
    };

    const handleSubmitEliminarAcceso = async () => {
        if (eliminarAccesoRef.current) return;
        eliminarAccesoRef.current = true;

        try {
            const idusuario = Number(usuarioActual?.id ?? 0);
            if (idusuario <= 0) {
                handleOpenAlert("Seleccione un acceso existente para eliminar.");
                return;
            }

            const result = await DeleteRequest({
                url: apiAccesosDelete.replace("{idusuario}", idusuario),
                loader: "Eliminando acceso...",
            });

            if (result?.hasError) {
                handleOpenAlert("Error al eliminar acceso: " + result.message);
                return;
            }

            setModalOpenEliminarAcceso(false);
            resetFormularioAccesos();
            await HandleCargarUsuarios();
            handleOpenAlert("Acceso eliminado correctamente.", "ok");
        } finally {
            eliminarAccesoRef.current = false;
        }
    };

    const handleTogglePermiso = (modulo) => {
        if (statusEnableFields) return;

        setPermisos((prev) =>
            prev.map((p) => (p.modulo === modulo ? { ...p, status: p.status ? 0 : 1 } : p))
        );
    };

    const handleToggleAlcance = (alcance) => {
        if (statusEnableFields) return;

        const raw = (alcance ?? "").trim().toUpperCase();
        const a = sanitizeForApi(raw);
        if (!a || a.length > 50) return;

        const existe = alcances.some((x) => x.alcance === a);

        setAlcances((prev) => {
            if (existe) return prev.filter((x) => x.alcance !== a);
            return [...prev, { usuario: sanitizeForApi(usuarioActual.usuario), alcance: a, id: usuarioActual.id }];
        });
    };
    
    const handleNuevoUsuario = () => {
        const u = getStructAccesosDefault();
        const rolBase = "USUARIO";
        const tree = buildTreeFromTemplate(getRoleRows(rolBase), rolBase);

        setUsuarioActual({
            ...u,
            tipousuario: rolBase,
        });
        setAccesoPayLoad(getStructAccesoPayload());

        setRolSeleccionado(rolBase);
        setMenus(tree);
        setMenusAccesos(tree);
        setPermisos([]);
        setAlcances([]);
        setStatusEnableFields(false);
        setStatusCanEdit(false);

        setSnapshotUsuario(deepClone({ ...u, tipousuario: rolBase }));
        setSnapshotMenus(deepClone(tree));
        setSnapshotPerm([]);
        setSnapshotAlc([]);
    };

    const handleClickRegresarMainDashboard = () => {
        const route = "/*";
        navigation(route);  
    };

    const hadleChangeStatusNuevo = (value) => {
        setStatusNuevo(value);
    }

    return (
        <AccesosContext.Provider
            value={{
                roles,
                usuarios, setUsuarios,
                usuarioActual, setUsuarioActual,
                menus, setMenus,
                menusAccesos, setMenusAccesos,
                permisos, setPermisos,
                alcances, setAlcances,

                usuarioSeleccionado, setUsuarioSeleccionado,
                rolSeleccionado, setRolSeleccionado,

                accesoPayLoad, setAccesoPayLoad, getStructAccesoPayload,
                statusEnableFields, setStatusEnableFields,
                statusCanEdit, setStatusCanEdit,

                HandleCargarUsuarios,
                handleCargarAccesoData,
                handleChangeDataAccesos,
                handleChangeDataAccesoPayload,
                handleCargarMenus,
                handleHotKeyChange,
                handleReordenMenus,
                handleReordenMenusPadres,

                tabIndex, setTabIndex,
                handleChangeTab,

                handleChangeTreeView,
                handleChangeMenusStatus,

                handleTogglePermiso,
                handleToggleAlcance,
                handleToggleMenu,

                handleObtenerMenus,
                handleObtenerPermisos,
                handleObtenerAlcances,

                handleGuardarCambiosUsuario,
                handleRevertirCambios,
                handleDeshacer,
                dirty,
                modalOpenEliminarAcceso,
                handleOpenEliminarAcceso,
                handleCloseEliminarAcceso,
                handleSubmitEliminarAcceso,

                handleNuevoUsuario,  
                handleClickRegresarMainDashboard,
                handleAplicarRol,

                statusNuevo,
                hadleChangeStatusNuevo,
            }}
        >
            {props.children}
        </AccesosContext.Provider>
    );
};

export const useAccesos = () => useContext(AccesosContext);
